/**
 * Language detection utilities — EPIC-06-04 AC-5.
 *
 * Uses a lightweight ASCII-dominant heuristic (no external API).
 * Text is treated as English when > 80% of its characters are ASCII
 * printable (U+0020–U+007E).
 */

/** Code-point range for ASCII printable characters (space through tilde). */
const ASCII_LOWER = 0x0020;
const ASCII_UPPER = 0x007e;

/**
 * Return true if `text` appears to be English.
 *
 * Heuristic: > 80% of characters must be ASCII printable (U+0020–U+007E).
 * Empty or whitespace-only strings always return false.
 */
export function isEnglish(text: string): boolean {
  if (!text || !text.trim()) return false;

  let asciiCount = 0;
  const total = text.length;

  for (let i = 0; i < total; i++) {
    const code = text.charCodeAt(i);
    if (code >= ASCII_LOWER && code <= ASCII_UPPER) {
      asciiCount++;
    }
  }

  return asciiCount / total > 0.8;
}
